import { batch, connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import { IconTileViewMobile } from '../../base/icons/svg';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
import { setOverflowMenuVisible } from '../../toolbox/actions';
import { setTileView } from '../actions';
/**
 * Component that renders a toolbar button for toggling the tile layout view.
 *
 * @augments AbstractButton
 */
class TileViewButtonMobile extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.enterTileView';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.exitTileView';
        this.label = 'toolbar.enterTileView';
        this.toggledLabel = 'toolbar.exitTileView';
        this.icon = IconTileViewMobile;
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        batch(() => {
            dispatch(setTileView(true));
            navigator.product !== 'ReactNative' && dispatch(setOverflowMenuVisible(false));
        });
    }
}
/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code TileViewButtonMobile} component.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component instance.
 * @returns {IProps}
 */
function _mapStateToProps(state, ownProps) {
    return {};
}
export default translate(connect(_mapStateToProps)(TileViewButtonMobile));
